import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { IonIcon, ModalController } from '@ionic/angular/standalone';
import { AvatarRoundComponent } from '@qid/super';
import { Participant } from '../../model/participant';

export type ParticipantSheetAction = 'makeAdmin' | 'dismissAdmin' | 'remove';

@Component({
  selector: 'participant-actions-sheet',
  templateUrl: './participant-actions-sheet.component.html',
  styleUrl: './participant-actions-sheet.component.scss',
  standalone: true,
  imports: [CommonModule, IonIcon, AvatarRoundComponent],
})
export class ParticipantActionsSheetComponent {
  @Input() participant!: Participant;
  @Input() canMakeAdmin = false;
  @Input() canDismissAdmin = false;
  @Input() canRemove = false;
  @Input() isSelf = false;

  private readonly modalController = inject(ModalController);

  get account() {
    return this.participant?.accountSnapshot || this.participant?.account;
  }

  get name(): string {
    return this.account?.name || this.participant?.name || 'Waiting for member';
  }

  get contact(): string | null {
    return (
      this.account?.email ||
      this.participant?.email ||
      this.account?.phoneNumber ||
      this.participant?.phoneNumber ||
      null
    );
  }

  get avatarUrl(): string | null {
    return this.account?.displayPictureUrl || this.participant?.facePhoto?.imageUrl || null;
  }

  select(action: ParticipantSheetAction): void {
    this.modalController.dismiss({ action });
  }

  dismiss(): void {
    this.modalController.dismiss();
  }
}
